import React, {createContext, useCallback, useContext, useEffect, useState} from "react";

import axios from "axios";
import api from "services/api";

import {useMsal} from "@azure/msal-react";
import {loginRequest} from "../../auth/authAzure";
import {getGroups} from "../../services/Graph.service";
import {toast} from "react-toastify";
import {i18n} from "translate/i18n";
import {getDashboardUser, setUsersDashboard} from "../../services/Users.service";

export const AppContext = createContext(0);

export const AuthProvider = (props) => {

    const { instance, accounts } = useMsal();

    const I18N_STORAGE_KEY = 'i18nextLng';
    //const [language] = useState(localStorage.getItem(I18N_STORAGE_KEY))
    const language = 'pt-BR';

    const authToken = useState(localStorage.getItem('access_token'));

    const [loading, setLoading] = useState(true);
    const [auth, setAuth] = useState(false);

    const [username, setUsername] = useState(null)

    const [user, setUser] = useState(null);


    useEffect(() => {
        const login = async () => {
            try {
                // 0. adquire o ID token do Azure uma vez (com os scopes do loginRequest, que ja
                //    funcionam no app) e guarda em localStorage para o /sanctum/token enviar como
                //    azure_token. Best-effort: sem ele, o backend usa o legado.
                try {
                    if (accounts && accounts[0]) {
                        const az = await instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
                        if (az?.idToken) {
                            localStorage.setItem("azure_id_token", az.idToken);
                        }
                    }
                } catch (e) {
                    console.log("azure id token indisponivel (seguindo sem):", e?.message);
                }

                // 1. token temporário
                await handleApiLogin();

                // 2. consulta/criação do usuário
                const dashboardUserId = await getDataUser();

                // 3. token final com usref correto
                if (dashboardUserId) {
                    await handleApiLogin(dashboardUserId);
                }
            } catch (error) {
                console.log("Erro no fluxo de autenticação", error);
            } finally {
                setLoading(false);
            }
        };

        login();
    }, []);


    const getDataUser = async () => {
        const azureId = accounts[0].localAccountId;
        const userName = accounts[0].name;
        const email = accounts[0].username;

        let profile = 5;
        let dashboardUserId = null;

        const getUserDashboard = await getDashboardUser(azureId);

        if (getUserDashboard) {
            profile = getUserDashboard.profile;
            dashboardUserId = getUserDashboard.id;
            localStorage.setItem("usref", dashboardUserId);
        } else {
            const data = {
                id: azureId,
                username: userName,
                email: email,
                profile: 7,
                status: 1,
                created_at: new Date()
            };

            const createUser = await setUsersDashboard(data);

            if (createUser?.success) {
                dashboardUserId = createUser?.user?.id ?? createUser?.id ?? data.id;
                localStorage.setItem("usref", dashboardUserId);
            }
        }

        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            getGroups(response.accessToken).then(response => {
                let access = [];
                let verify = false;
                setAuth(false);

                if (response) {
                    if (response.error) {
                        toast.error(i18n.t("error.badRequest"), { limit: 1 });
                        logout();
                        return;
                    }

                    response?.value?.map(item => access = [...access, item.id]);
                    verify = access.includes(azureId);
                    verify = true;
                }

                if (!verify) {
                    toast.error("Usuário não autorizado!", { limit: 1 });
                    logout();
                } else {
                    setAuth(true);
                }
            });
        });

        setUser({
            id: azureId,
            username: userName,
            email,
            profile
        });

        return dashboardUserId;
    };


    const handleApiLogin = useCallback(async (usref = null) => {
        const baseURL = process.env.REACT_APP_URL_API;

        try {
            const payload = {
                device_name: "check_user"
            };

            if (usref) {
                payload.usref = usref;
            }

            // Corte de autenticacao (IT:536): envia o ID token do Azure (adquirido no inicio do fluxo)
            // para o backend validar a identidade. Best-effort: sem ele, o backend usa o legado.
            const azureIdToken = localStorage.getItem("azure_id_token");
            if (azureIdToken) {
                payload.azure_token = azureIdToken;
            }

            const response = await axios.post(
                `${baseURL}/sanctum/token`,
                payload,
                {
                    headers: {
                        Accept: "application/json"
                    }
                }
            );

            api.defaults.headers.authorization = `Bearer ${response.data.access_token}`;
            localStorage.setItem("access_token", response.data.access_token);

            return response.data.access_token;
        } catch (error) {
            console.log("login-api", error);
            throw error;
        }
    }, []);



    const logout = () => {
        localStorage.removeItem("authToken");
        instance.logoutPopup().catch(e => {
            console.error(e);
        });
    }

    if(!auth) return <div className="loading">
        <div className="spinner-grow text-theme" role="status"/>
    </div>
    return (
        <AppContext.Provider
            value={{
                user,
                loading,
                language,
                username: user.username,
                logout:logout,
            }}>
            {props.children}
        </AppContext.Provider>
    )
}

export const useUser = () => useContext(AppContext);
